import {combineReducers} from 'redux';
import {agentDialogReducer} from './dialogs';
import {managementReducer} from './management';

export const agentsReducer = combineReducers({
  management: managementReducer,
  dialogs: agentDialogReducer,
});
